import { MessagesActions } from './messages/messages.actions';
import { PostEscalationCurationActions } from './post-escalation-curation/post-escalation-curation.actions';
import { OverlayActions } from './overlay-state/overlay.actions';
import { SafeSendActions } from './safe-send/safe-send.actions';
import { EmailTranscriptActions } from './email-transcript/email-transcript.actions';
import { WindowStateActions } from './window/window.actions';
import { ActionType, OverlayType } from '../types/enum';
import { AnalyticsAction } from './analytics/analytics.actions';

export const getComponentAction = (actionType: ActionType, store): any => {
  switch (actionType) {
    case ActionType.LinkClick:
      return (bubbleEvent) => {
        store.dispatch(MessagesActions.handleClickableLink({ bubbleEvent }));
      };
    case ActionType.CannedResponseClick:
      return (response: CannedResponse) => {
        store.dispatch(
          MessagesActions.handleCannedResponse({ response: response })
        );
      };
    case ActionType.onPostEscalationMenuSelection:
      return (value) => {
        store.dispatch(
          PostEscalationCurationActions.updateSelectedItems({
            value,
          })
        );
      };
    case ActionType.closeLiveChatConnection:
      return () => {
        store.dispatch(
          OverlayActions.showOverlay({ value: OverlayType.Confirmation })
        );
      };
    case ActionType.UpdateSafeSendStatus:
      return (value) => {
        store.dispatch(SafeSendActions.updateSafeSend({ value }));
      };
    case ActionType.HandlePayment:
      return () => {
        store.dispatch(OverlayActions.closeOverlay());
      };
    case ActionType.HandleCancelPayment:
      return () => {
        store.dispatch(OverlayActions.closeOverlay());
      };
    case ActionType.closeConfirmationOverlay:
      return () => {
        store.dispatch(OverlayActions.closeApplication());
      };
    case ActionType.onCancelPostEscalationMenuSelection:
      return () => {
        store.dispatch(AnalyticsAction.abandonedCurations());
        store.dispatch(OverlayActions.closeApplication());
      };
    case ActionType.cancelConfirmationOverlay:
      return () => {
        store.dispatch(OverlayActions.closeOverlay());
      };
    case ActionType.requestEmailTranscript:
      return (email: string) => {
        store.dispatch(EmailTranscriptActions.requestTranscript({ email }));
      };
    case ActionType.closeEmailTranscript:
      return () => {
        store.dispatch(WindowStateActions.closeWindow());
      };
  }
};
